import { Button, ButtonProps } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

type DiscardPcfButtonProps = {
  footprintId: number;
  productId: number;
} & ButtonProps;

const DiscardPcfButton = (props: DiscardPcfButtonProps): JSX.Element => {
  const { footprintId, productId, ...restProps } = props;
  const { t } = useTranslation();

  const { openDialog } = useDialogContext();

  const onClick = () => {
    openDialog('discard-pcf-dialog', { productId, footprintId });
  };

  return (
    <Button
      text
      label={t('productDetailsPage.tabs.pcfTab.buttons.discardButton')}
      onClick={onClick}
      {...restProps}
    />
  );
};

export default DiscardPcfButton;
